module.exports = __webpack_public_path__ + "img/video.7c8ea7b.jpg";